module.exports = __webpack_public_path__ + "static/media/Banner-asset.dd2a4fbc.webp";